import React from 'react';
import { AlertCircle } from 'lucide-react';
import { cn } from '../lib/utils';

export interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({ title, message, onRetry, className }: ErrorStateProps) {
  return (
    <div
      className={cn(
        'experience-candidate-error-state relative flex flex-col items-center justify-center overflow-hidden rounded-lg border border-red-200 bg-white px-6 py-10 text-center shadow-sm',
        className,
      )}
      role="alert"
    >
      <div className="experience-candidate-error-rule absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-red-300 to-transparent" />
      <div className="experience-candidate-error-icon flex h-12 w-12 items-center justify-center rounded-lg border border-red-200 bg-red-50">
        <AlertCircle
          className="experience-candidate-error-glyph h-7 w-7 text-red-500"
          aria-hidden="true"
        />
      </div>
      {title && (
        <p className="experience-candidate-error-copy mt-4 max-w-xl font-heading text-card-title text-red-900">
          {title}
        </p>
      )}
      {message && (
        <p
          className={cn(
            'experience-candidate-error-copy max-w-2xl font-body text-body-sm text-red-800',
            title ? 'mt-2' : 'mt-4',
          )}
        >
          {message}
        </p>
      )}
      {onRetry && (
        <button
          onClick={onRetry}
          className="experience-candidate-button experience-candidate-button-primary experience-candidate-motion experience-candidate-focus mt-5 inline-flex min-h-10 items-center justify-center rounded-lg border border-statura-green-accessible bg-statura-green-accessible px-4 py-2 font-body text-body-sm font-semibold text-white shadow-sm transition-interactive duration-200 hover:bg-statura-green-accessible-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-statura-green-accessible focus-visible:ring-offset-2"
        >
          Try again
        </button>
      )}
    </div>
  );
}
